import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PortalAuthState {
  sessionToken: string | null;
  email: string | null;
  practiceNames: string[];
  isAuthenticated: boolean;
  login: (sessionToken: string, email: string, practiceNames: string[]) => void;
  logout: () => void;
}

export const usePortalAuthStore = create<PortalAuthState>()(
  persist(
    (set) => ({
      sessionToken: null,
      email: null,
      practiceNames: [],
      isAuthenticated: false,
      login: (sessionToken, email, practiceNames) =>
        set({ sessionToken, email, practiceNames, isAuthenticated: true }),
      logout: () =>
        set({
          sessionToken: null,
          email: null,
          practiceNames: [],
          isAuthenticated: false,
        }),
    }),
    {
      name: "portal-auth-storage",
      partialize: (state) => ({
        sessionToken: state.sessionToken,
        email: state.email,
        practiceNames: state.practiceNames,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
